export type SalesCouponItem = {
  id: number;
  code: string;
  description: string;
  discount: number;
  maxDiscount: number;
  enabled: boolean;
  type: "PERCENTAGE" | "FIXED";
  expiryDate: string | null;
  expiryDateInput: string;
  addedOn: string | null;
  usageCount: number;
  status: "Active" | "Expired" | "Disabled";
};

export type SalesCouponsResponse = {
  coupons: SalesCouponItem[];
  pagination: {
    page: number;
    pageSize: number;
    totalCoupons: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
  };
  summary: {
    totalCoupons: number;
    activeCoupons: number;
    expiredCoupons: number;
    usedCoupons: number;
  };
};

async function parseResponse(response: Response) {
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(data?.message || `Request failed: ${response.status}`);
  }

  return data;
}

export async function fetchSalesCoupons(query: URLSearchParams) {
  const response = await fetch(`/api/sales/coupons?${query.toString()}`, {
    credentials: "include",
    headers: {
      Accept: "application/json"
    }
  });

  return (await parseResponse(response)) as SalesCouponsResponse;
}

export async function fetchSalesCoupon(couponId: number) {
  const response = await fetch(`/api/sales/coupons/${couponId}`, {
    credentials: "include",
    headers: {
      Accept: "application/json"
    }
  });

  return (await parseResponse(response)) as SalesCouponItem;
}
